<template>
    <div :class="{'maskLayer': isMaskLayer}" v-if="chooseCityAndGradeStatus.show">
        <div class="main-select">
            <div class="title">选择城市年级</div>
            <div class="content">
                <span class="content-title">所在城市</span>
                <ul class="btn-list">
                    <li v-for="cityItem in cityList" class="btn" :class="{'select-active':selectCity ==  cityItem.cityName}" @click="handleSelectCity(cityItem)">{{cityItem.cityName}}</li>
                </ul>

                <span class="content-title">在读年级</span>
                <ul class="btn-list">
                    <li v-for="classItem in gradeList" class="btn" :class="{'select-active':selectGrade ==  classItem.name}" @click="handleSelectGrade(classItem)">{{classItem.name}}</li>
                </ul>

                <div class="select-btn" :class="{'confirm-active':isConfirm, 'disabled':!isConfirm }" @click="handleConfirm">确定</div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations, mapActions} from 'vuex'
    import api from '../../../common/libs/api.js';
    import utils from '../../../common/libs/utils'
    import localforage from "localforage";
    export default {
        data() {
            return {
                selectCity: '',
                selectCityCode: '010',
                selectGrade: '',
                selectGradeId: '3',
                isConfirm: false,
                isMaskLayer: true,
                isClick: true,   // 防止按钮重复点击或点击过快
                cityList: [],
                gradeList: []
            }
        },
        watch: {
            selectCity(newVal) {
                const [{grade}] = this.cityList.filter(item => {
                    return item.cityName === newVal
                })
                this.gradeList = grade
                if (newVal === '上海' && this.selectGrade === '六年级') {
                    this.selectGrade = ''
                }

                this.updateConfirmStatus()
            },
            selectGrade(newVal) {
                this.updateConfirmStatus()
            }
        },
        computed: {
            ...mapState({
                chooseCityAndGradeStatus: state => state.chooseCityAndGrade,
                nowCity: state => state.home
            })
        },
        created() {
            // 进入该页面，默认禁用滑动
            // this.$store.commit('isScroll', true);
            this.getDiagnosisCityGrade()
        },
        mounted() {
           utils.cookie.del('token', '.izhikang.com', '/')
        },
        methods: {
            ...mapActions(['chooseCityAndGrade', 'updatePop', 'toastBlack']),
            ...mapMutations(['setCity']),
            /**
             * 同时监控城市以及年纪，当同时选中的时候，
             * 按钮颜色变化
             * @param e
             */
            updateConfirmStatus() {
                if (this.selectCity && this.selectGrade) {
                    this.isConfirm = true
                } else {
                    this.isConfirm = false
                }
            },
            /**
             * 处理选择所在城市
             * @param e
             */
            handleSelectCity(cityItem) {
                this.selectCity = cityItem.cityName
                this.selectCityCode = cityItem.cityCode
            },

            /**
             * 处理选择在读年纪
             * @param e
             */
            handleSelectGrade(classItem) {
                const { id, name} = classItem
                this.selectGrade = name
                this.selectGradeId = id
            },
            /**
             * 点击确认按钮之后的逻辑校验
             */
            handleConfirm() {
                if (this.isClick) {
                    this.setCity({
                        city_code: this.selectCityCode,
                        city_name: this.selectCity
                    })
                    utils.cookie.set('cityCode', this.selectCityCode, 'localhost', '/', 24*7);
                    utils.cookie.set('cityCode', this.selectCityCode, '.izhikang.com', '/', 24*7);
                    // 请求详情页面内容
                    this.getDiagnosis()

                    this.isClick = false
                    setTimeout( () => {
                        this.isClick = true
                    }, 1500)

                }
            },
            /**
             * 处理弹窗
             * @param content
             */
            popUps(content) {
                // this.$store.commit('isScroll', true);
                this.updatePop(content)
            },
            /**
             * 获取诊断课程的城市以及年级信息
             */
            getDiagnosisCityGrade() {
                this.$store.commit('isShowLoading', true)
                api.apiMethod.diagnosisCityGrade.get().then((res) => {
                    this.cityList = res.data.data
                    this.gradeList = this.cityList[0].grade
                }).finally(() => {
                    this.$store.commit('isShowLoading', false)
                })
            },
            /**
             * 获取详情页面产品ID以及产品类型
             */
            getDiagnosis() {
                const getParameter = {
                    cityCode: this.selectCityCode,
                    gradeId: this.selectGradeId
                }
                this.$store.commit('isShowLoading', true)
                api.apiMethod.getDiagnosis.get(getParameter).then((res) => {
                    // 需要将得到的结果内容返回到父组件
                    const data = res.data
                    if (data.errcode === 0) {
                        // 请求成功，放开对于scroll的禁用
                        // this.$store.commit('isScroll', false);
                        this.$emit('getDiagnosis', data.data, this.selectCityCode, this.selectGradeId)
                        // 更新vuex中课程信息
                        let cityData = {
                            city_code: this.selectCityCode,
                            city_name: this.selectCity,
                            grade_code: this.selectGradeId,
                            grade_name: this.selectGrade,
                            bizId: data.data.bizId
                        }
                        localStorage.removeItem('city-grade')
                        localStorage.setItem('city-grade', JSON.stringify(cityData));
                        // 关闭城市年级选择框
                        this.chooseCityAndGrade({show: false})
                    } else {
                        // 弹窗显示年纪选择不正确
                        // 如何是城市问题就是下列的内容，如果是 后台没有课程就是
                        // toast 展示
                        const msg = data.msg
                        const code = data.errcode
                        // 11000 默认是 需要弹窗
                        // 之前的文本是 "该年级的诊断课不存在或已下线" 是toast
                        if (code == 11000 ) {
                            this.popUps({
                                showPlus: true,
                                show: true,
                                title: '暂不能购买',
                                content: data.msg
                            })

                        } else {
                            this.toastBlack({
                                show: true,
                                title: msg
                            })
                        }
                        // if (msg == '该年级的诊断课不存在或已下线') {
                        // } else {
                        // }
                    }
                }).finally(() => {
                    this.$store.commit('isShowLoading', false)
                })
            }
        }
    }
</script>

<style scoped>
    .maskLayer {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 999;
    }
    .main-select {
        width: 100%;
        position: fixed;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        background-color: #FFFFFF;
        border-radius: 0.2rem 0.2rem 0 0;
        z-index: 99;
    }
    @media screen and (min-width: 1024px) {
        .main-select {
            max-width: 7.5rem;
        }
    }
    .title {
        text-align: center;
        height: 1.08rem;
        color: #333333;
        line-height: 1.08rem;
        font-size: 0.36rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        border-bottom: 0.02rem solid #F0F0F0;
    }
    .content {
        padding: 0.3rem;
    }
    .content-title {
        font-size: 0.28rem;
        color: #999999;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
    }
    .btn-list {
        display: flex;
        flex-wrap: wrap;
        margin: 0.1rem 0 0.3rem 0 ;
    }
    .btn-list .btn {
        width: 2.1rem;
        height: 0.88rem;
        /*padding: 0.3rem 0.77rem;*/
        border: 0.02rem solid #E2E2E2;
        border-radius: 0.08rem;
        margin: 0.1rem;
        text-align: center;
        line-height: 0.88rem;

        font-size: 0.28rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
    }
    .select-btn {
        width: 100%;
        height: 0.88rem;
        background-color: #E2E2E2;
        border-radius: 8px;

        text-align: center;
        line-height: 0.88rem;
        font-size: 0.32rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        margin: 0.67rem 0 0.4rem 0;
        overflow: hidden;
    }

    .btn.select-active {
        border-color:#CD0014;
        background-color:rgba(205, 0, 20, 0.05);
        color: #CD0014;
    }
    .confirm-active {
        background-color: #CD0014;
        color: #FFFFFF;
    }

    .disabled {
        pointer-events: none;
    }



</style>



// WEBPACK FOOTER //
// src/components/diagnosisCourse/detail/chooseCityAndGrade.vue